var map = {
	"./+.svg": "52ce",
	"./400-bad-request.svg": "6697",
	"./BELUM_LUNAS_WATERMARK.svg": "fb17",
	"./Bonus-Komisi-Icon-Collapse.svg": "7be3",
	"./Ill_Badge_Action-Success.svg": "3d3e",
	"./Ill_Badge_Login_Failed.svg": "4d36",
	"./Ill_badge_input_manifest_gagal.svg": "2681",
	"./LUNAS_WATERMARK.svg": "4cd7",
	"./Ranking.svg": "a73b",
	"./account-pin-lock.svg": "b072",
	"./action_success.svg": "e925",
	"./announce-fill.svg": "2972",
	"./announce-hanging.svg": "4627",
	"./announce.svg": "e004",
	"./announcement.svg": "06bd",
	"./are-you-sure.svg": "2b46",
	"./arrow-circle-left-red.svg": "d526",
	"./arrow-circle-left.svg": "ffbf",
	"./arrow-circle-right-red.svg": "eb9a",
	"./arrow-down-red.svg": "bb00",
	"./arrow-left.svg": "b58b",
	"./arrow-right-gray.svg": "593e",
	"./arrow-right-line.svg": "1771",
	"./arrow-right-white.svg": "d720",
	"./arrow-up-green.svg": "2e22",
	"./attachment-black.svg": "8583",
	"./attachment-chat.svg": "ccd2",
	"./attachment.svg": "3216",
	"./awb-not-found.svg": "7f44",
	"./awb-system-error.svg": "ca7b",
	"./badge-batik-air.svg": "e172",
	"./badge-confirmation-general.svg": "41e8",
	"./badge-exit-confirmation.svg": "8f60",
	"./badge-lion-air.svg": "50d0",
	"./badge-success-task.svg": "3190",
	"./badge-success.svg": "be65",
	"./badge-super-jet-air.svg": "8a0c",
	"./badge-warning-lg.svg": "a312",
	"./badge-wings-air.svg": "ce0c",
	"./bagging-list.svg": "dcfa",
	"./bagging.svg": "8bf2",
	"./balance-limit.svg": "e7cc",
	"./ban-white.svg": "c22b",
	"./ban.svg": "d3ba",
	"./bank-account-setting.svg": "ab4b",
	"./bank-red.svg": "922b",
	"./banner-insurance-v2.svg": "6c08",
	"./bg-client-circle-long.svg": "c011",
	"./bg-client-circle.svg": "8f1b",
	"./bg-dispute-summary.svg": "7ae0",
	"./bg-dot-pattern-long.svg": "0fc9",
	"./bg-dot-pattern.svg": "4420",
	"./bg-header-before-sti-dest.svg": "9244",
	"./bg-header-stt-overdue-del.svg": "b009",
	"./bg-header-stt-should-del.svg": "e454",
	"./bg-must-sti-booking.svg": "d3df",
	"./bg-qr-code-hub.svg": "9d68",
	"./bg-scan-shipment.svg": "5ae5",
	"./bg-shipment-booked.svg": "34fb",
	"./bg-sti-summary-stt.svg": "3f75",
	"./bg-summary-card-yellow.svg": "9641",
	"./bg-summary-card.svg": "af03f",
	"./bg-summary-limit.svg": "74d2",
	"./book.svg": "5140",
	"./booking-client.svg": "ed68",
	"./boss.svg": "8183",
	"./box-bkd.svg": "cf66",
	"./box-money-inactive.svg": "970e",
	"./box-money.svg": "1378",
	"./box_no_data.svg": "be2f",
	"./bulk-booking.svg": "9bf5",
	"./bulk.svg": "f21d",
	"./calendar-outlined.svg": "d5da",
	"./calendar.svg": "32f5",
	"./cancel-success.svg": "8d8f",
	"./cargo-unavailable.svg": "f09c",
	"./cargo.svg": "5230",
	"./cash.svg": "bba7",
	"./cash_white.svg": "044e",
	"./chart-bar-solid.svg": "77fc",
	"./check-blue.svg": "4e50",
	"./check-circle-border-green.svg": "b318",
	"./check-circle-border-white.svg": "9752",
	"./check-circle-border.svg": "8fa5",
	"./check-circle-disable.svg": "d31d",
	"./check-circle-gray.svg": "c181",
	"./check-circle-red.svg": "4067",
	"./check-circle.svg": "c894",
	"./check-red.svg": "ae8d",
	"./check-silver-circle.svg": "463b",
	"./check-yellow.svg": "7f15",
	"./check.svg": "7ddf",
	"./check_circle.svg": "3351",
	"./chevron-down-black.svg": "7c75",
	"./chevron-down-bold-red.svg": "0285",
	"./chevron-down-disable.svg": "deb3",
	"./chevron-down-light.svg": "0e6c",
	"./chevron-down-new.svg": "b592f",
	"./chevron-down-red.svg": "432b",
	"./chevron-down-white.svg": "0b19",
	"./chevron-down.svg": "4227",
	"./chevron-left-white.svg": "44fa",
	"./chevron-left.svg": "4973",
	"./chevron-next.svg": "2843",
	"./chevron-prev.svg": "f839",
	"./chevron-right-black.svg": "3fc2",
	"./chevron-right-orange.svg": "cf7a",
	"./chevron-right-red.svg": "2a1c",
	"./chevron-right-white.svg": "8911",
	"./chevron-right.svg": "53f6",
	"./chevron-up-light.svg": "0a8c",
	"./chevron-up-new.svg": "550e",
	"./chevron-up-red.svg": "4fe3",
	"./chevron-up-white.svg": "faaf",
	"./chevron-up.svg": "4705",
	"./chevron_circle.svg": "a970",
	"./circle-error.svg": "9851",
	"./circle-green.svg": "2b46a",
	"./circle-red.svg": "477b",
	"./circle.svg": "ba96",
	"./client-ilustration.svg": "d91c",
	"./client-list.svg": "6bb5",
	"./clipboard-list.svg": "4ea3",
	"./clock-exclamation.svg": "9adf",
	"./clock-normal-red.svg": "d2c3",
	"./clock-normal.svg": "b29e",
	"./clock-orange.svg": "81bb",
	"./clock-red.svg": "89c2",
	"./clock-warning.svg": "5d77",
	"./clock.svg": "baab",
	"./clock2.svg": "fb27",
	"./close-border-red.svg": "ec24",
	"./close-circle.svg": "ebf1",
	"./close-icon-notif.svg": "a01a",
	"./close-white.svg": "b71d",
	"./close_circle.svg": "681e",
	"./close_white_icon.svg": "4175",
	"./cloud-download.svg": "b6d7",
	"./cloud-upload-sidebar.svg": "0d8f",
	"./cloud-upload.svg": "b48f",
	"./cod-badge-inactive.svg": "1691",
	"./cod-badge.svg": "9fcb",
	"./cod-label.svg": "1358",
	"./cod-logo-2.svg": "6f4d",
	"./cod-logo-3.svg": "8e24",
	"./cod-red.svg": "8e80",
	"./codrej-hanging.svg": "b62c",
	"./coin-red.svg": "dfad",
	"./coin-yellow.svg": "1039",
	"./collectible-card-lp-back.svg": "8408",
	"./collectible-card-total-background-large.svg": "3776",
	"./collectible-card-total-background.svg": "06e6",
	"./commissionConfig.svg": "f93b",
	"./commissionSum.svg": "a285",
	"./copy-clipboard.svg": "cd23",
	"./courier-pickup.svg": "f01a",
	"./cover-login.svg": "d68e",
	"./create-faq.svg": "b929",
	"./custom-process.svg": "cd77",
	"./dashboard.svg": "02d8",
	"./data-not-found.svg": "8d58",
	"./deadline-expired.svg": "e6db",
	"./del-hanging.svg": "ec6b",
	"./delete-confirm.svg": "21349",
	"./delete-success.svg": "0d44",
	"./delete.svg": "c141",
	"./delivery-proccess.svg": "3f18",
	"./delivery.svg": "b79d",
	"./dex-assesment/cpu-icon.svg": "2e22d",
	"./dex-hanging.svg": "ad23",
	"./dfod-badge-inactive.svg": "a3a5",
	"./dfod-badge.svg": "c0df",
	"./dfod-logo-2.svg": "4823",
	"./dfod.svg": "fabc",
	"./dispatch/dispatch_error.svg": "bfc1",
	"./dispatch/dispatch_internet_error.svg": "f813",
	"./dispatch/dispatch_server_error.svg": "616c",
	"./dispatch/kondispatch_partially.svg": "e356",
	"./dispatch/kondispatch_success.svg": "59ac",
	"./dispatch/stldispatch_partially.svg": "b6af",
	"./dispatch/stldispatch_success.svg": "bfb2",
	"./dispute-background-ornament.svg": "680e",
	"./document-add.svg": "e99e",
	"./document-download-border.svg": "4e6d",
	"./document-download-outline-grey.svg": "8163",
	"./document-download-outline-white.svg": "f026",
	"./document-download-outline.svg": "c95f",
	"./document-download-red.svg": "cd7f",
	"./document-download.svg": "5097",
	"./document-text.svg": "d3e4",
	"./dot-black.svg": "e60c",
	"./download-gray.svg": "856c",
	"./download-new-gray.svg": "4cd1",
	"./download-new.svg": "ae2b",
	"./download-white.svg": "14a1",
	"./download.svg": "a5a4",
	"./dry.svg": "0987",
	"./duplicate.svg": "730a",
	"./edit-button-remark.svg": "7587",
	"./ellipse.svg": "c072",
	"./emoji-chat.svg": "ef29",
	"./empty-black.svg": "a156",
	"./empty-flight-schedule-v2.svg": "e010",
	"./empty-flight-schedule.svg": "9bc2",
	"./empty-reverse-scan.svg": "c899",
	"./empty.svg": "9f86",
	"./error-internet.svg": "8043",
	"./error-token-ngen.svg": "4ec0",
	"./exchange -rate.svg": "aa8d2",
	"./exclamation-circle-solid-gray.svg": "0b61",
	"./exclamation-circle-solid-yellow.svg": "a6fc",
	"./exclamation-circle-solid.svg": "678e",
	"./exclamation-triangle-red.svg": "8a21",
	"./exclamation-triangle.svg": "6350",
	"./exclamation-yellow.svg": "ef59",
	"./eye.svg": "d713",
	"./eye_gray.svg": "7f7c",
	"./failed-status.svg": "d77d",
	"./file.svg": "0151",
	"./flag/australia.svg": "2b16",
	"./flag/austria.svg": "5b5b",
	"./flag/bangladesh.svg": "3eb5",
	"./flag/belgium.svg": "de31",
	"./flag/brazil.svg": "9c95",
	"./flag/brunei.svg": "274f",
	"./flag/cambodia.svg": "e5ed",
	"./flag/canada.svg": "12e8",
	"./flag/china.svg": "af3f",
	"./flag/costa_rica.svg": "b09f",
	"./flag/denmark.svg": "c925",
	"./flag/egypt.svg": "db0c",
	"./flag/findland.svg": "68b9",
	"./flag/france.svg": "2ced",
	"./flag/germany.svg": "c075",
	"./flag/greece.svg": "358a",
	"./flag/hongkong.svg": "2828",
	"./flag/india.svg": "34ef",
	"./flag/indonesia.svg": "87a7",
	"./flag/italy.svg": "7d4e",
	"./flag/jepang.svg": "33be",
	"./flag/kazakhstan.svg": "b679",
	"./flag/korea.svg": "c3f3",
	"./flag/kuwait.svg": "2b59",
	"./flag/macau.svg": "c5dc",
	"./flag/malaysia.svg": "1df3",
	"./flag/mexico.svg": "6ff2c",
	"./flag/monaco.svg": "7e94",
	"./flag/morocco.svg": "b442",
	"./flag/netherland.svg": "64ad",
	"./flag/newzeland.svg": "6973",
	"./flag/oman.svg": "c32a",
	"./flag/pakistan.svg": "43d9",
	"./flag/peru.svg": "8213",
	"./flag/philippines.svg": "10c1",
	"./flag/qatar.svg": "2b96",
	"./flag/saudi_arabia.svg": "58fb",
	"./flag/singapore.svg": "2afa",
	"./flag/south_africa.svg": "ef54",
	"./flag/spain.svg": "6b8e",
	"./flag/sri_lanka.svg": "650b",
	"./flag/sweden.svg": "f847",
	"./flag/taiwan.svg": "547d",
	"./flag/thailand.svg": "e2ea",
	"./flag/timor-leste.svg": "f6b7",
	"./flag/turkey.svg": "409c",
	"./flag/uk.svg": "821e",
	"./flag/uni_emirate_arab.svg": "464a",
	"./flag/usa.svg": "0d82",
	"./flag/venezuela.svg": "a6fe",
	"./flag/vietnam.svg": "aa10",
	"./flight-ID-batik-circle.svg": "56ba",
	"./flight-IU-super-airjet-circle.svg": "0c28",
	"./flight-IW-wings-circle.svg": "324c",
	"./flight-JT-lion-circle.svg": "5afd",
	"./flight-schedule-not-found.svg": "d37d",
	"./flight_land.svg": "008d",
	"./flight_takeoff.svg": "2f6b",
	"./floating-booking.svg": "80ad",
	"./frame-image.svg": "d637",
	"./freeze.svg": "8401",
	"./frozen.svg": "5a5a",
	"./guide-photo-one.svg": "de40",
	"./guide-photo-two.svg": "2ed0",
	"./handover.svg": "dd59",
	"./hanging-email.svg": "14c7",
	"./help-desk.svg": "5310",
	"./history-hanging.svg": "400d",
	"./history-reconcile.svg": "1274",
	"./hourglass-illustration.svg": "005d",
	"./hourglass.svg": "0fdc",
	"./hub.svg": "7aa3",
	"./ic_arrow_range.svg": "ad28",
	"./ic_checker_hanging.svg": "98fc",
	"./ic_circle_green.svg": "4bbc",
	"./ic_circle_red.svg": "a17b",
	"./ic_circle_yellow.svg": "e8de",
	"./ic_console_hanging.svg": "70cb",
	"./ic_courier_hanging.svg": "c2ca",
	"./ic_failed_unread.svg": "6b0e",
	"./ic_followup_client.svg": "cecf",
	"./ic_followup_console.svg": "d1f0",
	"./ic_pic.svg": "67c4",
	"./ic_pic_hanging.svg": "55f4",
	"./ic_plane_hanging.svg": "ddbe",
	"./ic_search_hanging.svg": "0785",
	"./ic_truck_hanging.svg": "f604",
	"./icon-area-scan.svg": "4cc8",
	"./icon-arrow-left.svg": "0998",
	"./icon-arrow-right.svg": "22ba",
	"./icon-check-circle-red.svg": "6bee",
	"./icon-check-white.svg": "ed64",
	"./icon-close-black.svg": "66e1",
	"./icon-dot.svg": "fefe",
	"./icon-edit-dash.svg": "d1c8",
	"./icon-excel.svg": "6720",
	"./icon-exclamation-white.svg": "7713",
	"./icon-play-video.svg": "9f4d",
	"./icon-shield-white.svg": "5e56",
	"./icon-stt.svg": "1b9d",
	"./icon-task-white.svg": "ca08",
	"./icon-time-white.svg": "effe",
	"./icon-x-white.svg": "5b80",
	"./icon_camera.svg": "d6bd",
	"./icp-scan.svg": "2a56",
	"./ics_close.svg": "3c62",
	"./ics_download-template.svg": "e2b8",
	"./ics_ellipse.svg": "2cae",
	"./ics_f_announce.svg": "12d6",
	"./ics_f_announce_green.svg": "aba5",
	"./ics_f_announce_red.svg": "1904",
	"./ics_f_announce_sdn.svg": "e110",
	"./ics_f_announce_yellow.svg": "9c3c3",
	"./ics_f_arrow-circle-right.svg": "193c",
	"./ics_f_chat_warning.svg": "c3f7",
	"./ics_f_check_circle.svg": "f292",
	"./ics_f_check_circle_gray.svg": "977d",
	"./ics_f_check_circle_green.svg": "74f8",
	"./ics_f_clock2_orange.svg": "be6a",
	"./ics_f_close_circle.svg": "5ad2",
	"./ics_f_copy.svg": "6dba",
	"./ics_f_cursor.svg": "0a27",
	"./ics_f_info_circle.svg": "077e",
	"./ics_f_info_circle_blue.svg": "a873",
	"./ics_f_info_circle_dark_blue.svg": "2912",
	"./ics_f_info_circle_gray.svg": "b17a",
	"./ics_f_info_circle_yellow.svg": "9cf2",
	"./ics_f_kg_circle.svg": "6891",
	"./ics_f_location_pin.svg": "5ea3",
	"./ics_f_min_circle.svg": "257d",
	"./ics_f_plane_flight_line.svg": "6a3e",
	"./ics_f_plus_circle.svg": "c4e6",
	"./ics_f_save.svg": "a9e8",
	"./ics_f_star.svg": "1832",
	"./ics_f_thumb-bad-disabled.svg": "c176",
	"./ics_f_thumb-bad-white.svg": "0079",
	"./ics_f_thumb-bad.svg": "26bf",
	"./ics_f_thumb-good-disabled.svg": "3d8f",
	"./ics_f_thumb-good-white.svg": "81d7",
	"./ics_f_thumb-good.svg": "a37d",
	"./ics_f_thumb-neutral-disabled.svg": "5578",
	"./ics_f_thumb-neutral-white.svg": "7a74",
	"./ics_f_thumb-neutral.svg": "f9e0",
	"./ics_f_trash.svg": "887d",
	"./ics_f_warning_circle.svg": "56f5",
	"./ics_f_warning_circle_red.svg": "952f",
	"./ics_f_warning_triangles.svg": "cb5b",
	"./ics_f_whatsapp.svg": "1076",
	"./ics_o_active_client.svg": "4d45",
	"./ics_o_arrow_down.svg": "286a",
	"./ics_o_arrow_left.svg": "ef44",
	"./ics_o_arrow_right.svg": "d714",
	"./ics_o_arrow_right_red.svg": "e517",
	"./ics_o_arrow_up.svg": "46ad",
	"./ics_o_barcode.svg": "3055",
	"./ics_o_boat.svg": "b948",
	"./ics_o_booking.svg": "2d0a",
	"./ics_o_booking_white.svg": "61c3",
	"./ics_o_box.svg": "78a7",
	"./ics_o_box_alt.svg": "ba2b",
	"./ics_o_briefcase.svg": "c6eb",
	"./ics_o_chevron_left.svg": "b979",
	"./ics_o_chevron_right-red.svg": "e3de",
	"./ics_o_chevron_sort.svg": "c091",
	"./ics_o_chevron_sort_asc.svg": "283c",
	"./ics_o_chevron_sort_desc.svg": "3f7e",
	"./ics_o_clipboard.svg": "06ae",
	"./ics_o_clock2.svg": "8369",
	"./ics_o_clock_warning_red.svg": "48ee",
	"./ics_o_close.svg": "2e4c",
	"./ics_o_close_red.svg": "521d",
	"./ics_o_cod_amount.svg": "002b",
	"./ics_o_cod_rej.svg": "f654",
	"./ics_o_commodity.svg": "af75",
	"./ics_o_commodity_v2.svg": "5be5",
	"./ics_o_commodity_v2_active.svg": "45ef",
	"./ics_o_contactNote.svg": "6659",
	"./ics_o_delivery_process.svg": "6390",
	"./ics_o_delivery_received.svg": "1294",
	"./ics_o_destination.svg": "6664",
	"./ics_o_destination_active.svg": "4d66",
	"./ics_o_dex_package.svg": "0d6f",
	"./ics_o_document_gray.svg": "fee7",
	"./ics_o_document_red.svg": "0944",
	"./ics_o_download.svg": "3a64",
	"./ics_o_download_2.svg": "02c8",
	"./ics_o_download_circle.svg": "5364",
	"./ics_o_download_circle_disabled.svg": "ab29",
	"./ics_o_download_pdf.svg": "fc3c",
	"./ics_o_download_pdf_struk.svg": "5cb7",
	"./ics_o_download_png.svg": "a556",
	"./ics_o_edit.svg": "1554",
	"./ics_o_edit_dash_black.svg": "61da",
	"./ics_o_edit_plus.svg": "94b5",
	"./ics_o_edit_red.svg": "ab9f",
	"./ics_o_eye.svg": "1b6d",
	"./ics_o_eye_disabled.svg": "e596",
	"./ics_o_eye_red.svg": "44c1",
	"./ics_o_filter.svg": "10c6",
	"./ics_o_filter_red.svg": "ce0f",
	"./ics_o_flight-land.svg": "1c0bc",
	"./ics_o_flight-takeoff.svg": "79d0",
	"./ics_o_globe.svg": "590e",
	"./ics_o_info_circle.svg": "91a4",
	"./ics_o_info_circle_gray.svg": "bb29",
	"./ics_o_kirim_tagihan.svg": "92f0",
	"./ics_o_maps.svg": "8aab",
	"./ics_o_mention.svg": "4a32",
	"./ics_o_min_circle.svg": "5964",
	"./ics_o_min_circle_active.svg": "9014",
	"./ics_o_more.svg": "da79",
	"./ics_o_multiple_file.svg": "7feb",
	"./ics_o_on_delivery.svg": "279b",
	"./ics_o_package-crrdon.svg": "cc53",
	"./ics_o_package-crrotw.svg": "f690",
	"./ics_o_package-crrpic.svg": "37f8",
	"./ics_o_package_failed.svg": "c280",
	"./ics_o_package_failed_crrdon.svg": "324f",
	"./ics_o_package_failed_crrnfd.svg": "9326",
	"./ics_o_package_failed_crrotw.svg": "171f",
	"./ics_o_package_failed_crrpic.svg": "2317",
	"./ics_o_person.svg": "b0c4",
	"./ics_o_plane-booking-black.svg": "d50f",
	"./ics_o_plus.svg": "19df",
	"./ics_o_plus_gray.svg": "19610",
	"./ics_o_pos.svg": "0bef",
	"./ics_o_pos_active.svg": "c31a",
	"./ics_o_print.svg": "2397",
	"./ics_o_print_red.svg": "8316",
	"./ics_o_profile.svg": "ec93",
	"./ics_o_profile_active.svg": "d1cc",
	"./ics_o_reload.svg": "8c5a",
	"./ics_o_reload_gray.svg": "ce8d",
	"./ics_o_save.svg": "cd9d",
	"./ics_o_search.svg": "9b76",
	"./ics_o_search_gray.svg": "2adc",
	"./ics_o_services.svg": "0091",
	"./ics_o_services_active.svg": "5843",
	"./ics_o_shipping_service.svg": "bc52",
	"./ics_o_shipping_service_active.svg": "94c0",
	"./ics_o_sort.svg": "0e1f",
	"./ics_o_sort_active.svg": "7a20",
	"./ics_o_star.svg": "537c",
	"./ics_o_sync.svg": "44f0",
	"./ics_o_sync_white.svg": "f5a0",
	"./ics_o_train-booking-black.svg": "3b98",
	"./ics_o_trash.svg": "b3b6",
	"./ics_o_truck-booking-black.svg": "c412",
	"./ics_o_truck.svg": "dc1c",
	"./ics_o_ubah_tagihan.svg": "f683",
	"./ics_o_update_lunas.svg": "e11f",
	"./ics_o_urgent_delivery.svg": "4746",
	"./ics_o_wallet.svg": "e07d",
	"./ics_o_warning_triangles.svg": "e560",
	"./ics_o_whatsapp-background.svg": "bb47",
	"./ill_approval_default.svg": "725c",
	"./ill_badge_claim_confirmation.svg": "de75",
	"./ill_badge_failed.svg": "6164",
	"./ill_badge_print_lebel_pending.svg": "41e3",
	"./ill_badge_profile_block_user.svg": "70e9",
	"./ill_badge_profile_pin_lock.svg": "449e",
	"./ill_badge_request_cod.svg": "9631",
	"./ill_badge_request_pickup.svg": "a603",
	"./ill_badge_success.svg": "aeba",
	"./ill_badge_tariff_not_available.svg": "b3ca",
	"./ill_calendar.svg": "0105",
	"./ill_hanging_confirmation.svg": "ce01",
	"./ill_pakket_full.svg": "c78d",
	"./ill_pakket_full_green.svg": "9694",
	"./ill_spot_ask_box.svg": "24be",
	"./ill_spot_cancel_pickup.svg": "79d6",
	"./ill_spot_da_out_of_range.svg": "a6a2",
	"./ill_spot_embargo.svg": "10db",
	"./ill_spot_failed_scan_stt.svg": "05ee",
	"./ill_spot_info_tnc.svg": "f2ad",
	"./ill_spot_miscellaneous.svg": "02bd",
	"./ill_spot_search.svg": "2d8e",
	"./ill_spot_search_2.svg": "fb2c",
	"./ill_spot_success_scan_stt.svg": "b91c",
	"./ill_spot_unavailable_location.svg": "9895",
	"./ill_toko_unavailable.svg": "877a",
	"./illustration_waiting_process.svg": "6664c",
	"./image-modal-failed.svg": "0175",
	"./image-modal-on-process.svg": "1498",
	"./image-modal-success.svg": "b22c",
	"./image-modal-warning.svg": "4c83",
	"./in-hub-logo-partially.svg": "7d5e",
	"./in_hub_logo.svg": "d30b",
	"./inactive-account.svg": "896b",
	"./inactive-location.svg": "8892",
	"./info-red.svg": "0df7",
	"./info-square.svg": "c7fd",
	"./info-white.svg": "0029",
	"./info.svg": "2659",
	"./information-circle-green-1.svg": "b21f",
	"./information-circle-red.svg": "1fb2",
	"./information-circle-yellow.svg": "0de0",
	"./information-circle.svg": "f437",
	"./information.svg": "2627",
	"./insight.svg": "01a2",
	"./instant-booking-logo.svg": "50dc",
	"./instant-booking.svg": "810c",
	"./insurance-info.svg": "d6b1",
	"./invisible.svg": "71c8",
	"./invoice-gray.svg": "8f6e",
	"./invoice.svg": "8ee6",
	"./kejarcuan/active-1.svg": "ee2c",
	"./kejarcuan/active-10.svg": "c742",
	"./kejarcuan/active-11.svg": "1e0b",
	"./kejarcuan/active-12.svg": "811a",
	"./kejarcuan/active-13.svg": "6ee9",
	"./kejarcuan/active-14.svg": "7fc6",
	"./kejarcuan/active-15.svg": "8a35",
	"./kejarcuan/active-16.svg": "6f32",
	"./kejarcuan/active-17.svg": "bb81",
	"./kejarcuan/active-18.svg": "e489",
	"./kejarcuan/active-19.svg": "13d0",
	"./kejarcuan/active-2.svg": "23f1",
	"./kejarcuan/active-20.svg": "270e",
	"./kejarcuan/active-21.svg": "506b",
	"./kejarcuan/active-22.svg": "81c7",
	"./kejarcuan/active-23.svg": "de93",
	"./kejarcuan/active-24.svg": "068f",
	"./kejarcuan/active-25.svg": "acf2",
	"./kejarcuan/active-26.svg": "0bdd",
	"./kejarcuan/active-27.svg": "88f6e",
	"./kejarcuan/active-28.svg": "ee88",
	"./kejarcuan/active-29.svg": "92e7",
	"./kejarcuan/active-3.svg": "62e7",
	"./kejarcuan/active-30.svg": "14b5",
	"./kejarcuan/active-4.svg": "d3a60",
	"./kejarcuan/active-5.svg": "fb71",
	"./kejarcuan/active-6.svg": "6947",
	"./kejarcuan/active-7.svg": "6fe7",
	"./kejarcuan/active-8.svg": "60ca",
	"./kejarcuan/active-9.svg": "2703",
	"./kejarcuan/checklist-kejarcuan.svg": "bf64",
	"./kejarcuan/inactive-1.svg": "59f6",
	"./kejarcuan/inactive-10.svg": "2556",
	"./kejarcuan/inactive-11.svg": "f0c6",
	"./kejarcuan/inactive-12.svg": "499b",
	"./kejarcuan/inactive-13.svg": "343f",
	"./kejarcuan/inactive-14.svg": "d9f4",
	"./kejarcuan/inactive-15.svg": "73d0",
	"./kejarcuan/inactive-16.svg": "c962",
	"./kejarcuan/inactive-17.svg": "25a5",
	"./kejarcuan/inactive-18.svg": "0240",
	"./kejarcuan/inactive-19.svg": "34ba",
	"./kejarcuan/inactive-2.svg": "e857",
	"./kejarcuan/inactive-20.svg": "b556",
	"./kejarcuan/inactive-21.svg": "9adb",
	"./kejarcuan/inactive-22.svg": "663d",
	"./kejarcuan/inactive-23.svg": "9673",
	"./kejarcuan/inactive-24.svg": "4516",
	"./kejarcuan/inactive-25.svg": "336e",
	"./kejarcuan/inactive-26.svg": "45f6",
	"./kejarcuan/inactive-27.svg": "a6f31",
	"./kejarcuan/inactive-28.svg": "dd81",
	"./kejarcuan/inactive-29.svg": "9dff",
	"./kejarcuan/inactive-3.svg": "b7f7",
	"./kejarcuan/inactive-30.svg": "16d8",
	"./kejarcuan/inactive-4.svg": "ae7b",
	"./kejarcuan/inactive-5.svg": "5f0a",
	"./kejarcuan/inactive-6.svg": "b457",
	"./kejarcuan/inactive-7.svg": "c522",
	"./kejarcuan/inactive-8.svg": "29e4",
	"./kejarcuan/inactive-9.svg": "7639",
	"./kejarcuan/kejarcuan-logo.svg": "f736",
	"./kulioner-must-buy.svg": "ef56",
	"./kulioner-not-buy.svg": "1604",
	"./kulioner-was-buy.svg": "8fb31",
	"./kurir-hanging.svg": "ac09",
	"./leaving-page-illustration.svg": "e1be",
	"./leg-management.svg": "dff5",
	"./level/bronze.svg": "2ceb",
	"./level/diamond.svg": "1559",
	"./level/gold.svg": "7e59",
	"./level/platinum.svg": "5c32",
	"./level/silver.svg": "ad52",
	"./library.svg": "081e",
	"./line-horizontal.svg": "7427",
	"./lion-parcel-red.svg": "f932",
	"./list-doc.svg": "2881",
	"./loading-gray.svg": "ebfc",
	"./location-pin.svg": "bc51",
	"./lock-white.svg": "c714",
	"./login-approval/empty-history.svg": "acaa",
	"./login-approval/login-rejected.png": "c8b9",
	"./login-approval/logo-approval.svg": "1894",
	"./login-failed.svg": "673e",
	"./login-img.svg": "13cb",
	"./logo-client.svg": "a390",
	"./logo-console.svg": "5358",
	"./logo-general.svg": "e736",
	"./logo-genesis-new.svg": "6c18",
	"./logo-genesis-with-text.svg": "8ddf",
	"./logo-genesis.svg": "8cec",
	"./logo-internal.svg": "5b0b",
	"./logo-lion-parcel-red.svg": "b9a5",
	"./logo-lion-parcel.svg": "880f",
	"./logo-lion.svg": "270b",
	"./logo-pos.svg": "d4f4",
	"./logo-sender.svg": "3364",
	"./logo-sub-console.svg": "324d",
	"./logo-vendor.svg": "96d7",
	"./logo.svg": "34cd",
	"./logout-image.svg": "39f0",
	"./logout-red.svg": "0a73",
	"./logout.svg": "d5fc",
	"./mail.svg": "c596a",
	"./manual-deduct.svg": "cdda",
	"./max-koli-plane.svg": "2493",
	"./minipack-badge.svg": "7cbc",
	"./more-data-table.svg": "bd75",
	"./multi-people.svg": "fb37",
	"./new-badge-failed.svg": "5b36",
	"./new-cod-disabled.svg": "35ea",
	"./new-cod.svg": "c611",
	"./new-dfod-2.svg": "a57b",
	"./new-dfod-disabled.svg": "10da",
	"./new-dfod.svg": "0075",
	"./new-message.svg": "96a1",
	"./next-arrow-red.svg": "9a3b",
	"./next-arrow.svg": "f7c4",
	"./no-address.svg": "bd38",
	"./no-data-incoming-outgoing.svg": "adc6",
	"./no-data-list.svg": "f1ab",
	"./no-internet.svg": "dc90",
	"./no-notif.svg": "0bc5",
	"./noData_empty.svg": "d119",
	"./noData_empty_new.svg": "5798",
	"./noData_filter.svg": "93e5",
	"./not-found.svg": "f37a",
	"./notebook-slash-gray.svg": "f290",
	"./notes-reconcile.svg": "ab0fd",
	"./notification.svg": "f44b",
	"./on-process-booking-cargo.svg": "0ea4",
	"./option-gray.svg": "b891",
	"./option.svg": "56b6",
	"./ornament.svg": "7757",
	"./out-hub-logo-partially.svg": "fee4",
	"./out_hub_logo.svg": "129c",
	"./paper-clip-pencil.svg": "11a7",
	"./partially-status.svg": "9c56",
	"./partially.svg": "2b2a",
	"./password_saved.svg": "8c40",
	"./payment-button.svg": "4d25",
	"./payment.svg": "10fa",
	"./payment/example-qr.svg": "48f9",
	"./payment/logo-bca_qris-active.svg": "3d01",
	"./payment/logo-bca_qris-inactive.svg": "2a00",
	"./payment/logo-bca_qris2-active.svg": "ab0f",
	"./payment/logo-gopay_qris-active.svg": "79ce",
	"./payment/logo-gopay_qris-inactive.svg": "4535",
	"./payment/logo-linkaja_qris-active.svg": "26d2",
	"./payment/logo-linkaja_qris-inactive.svg": "c844",
	"./payment/logo-ovo_qris-active.svg": "06a6",
	"./payment/logo-ovo_qris-inactive.svg": "ad1d",
	"./payment/logo-ovo_qris2-active.svg": "88f6",
	"./payment/logo-shopeepay_qris-active.svg": "3320",
	"./payment/logo-shopeepay_qris-inactive.svg": "b404",
	"./payment/payment-cash-illustration.svg": "d3c4",
	"./payment/payment-failed-illustration.svg": "9f244",
	"./payment/payment-success-illustration.svg": "1659",
	"./payment/payment-timeout-illustration.svg": "0e2d",
	"./payment/success-booking-illustration.svg": "e8f2",
	"./pencil-alt-disable.svg": "da8f",
	"./pencil-alt-grey.svg": "ccb6",
	"./pencil-alt-white.svg": "b142",
	"./pencil-alt.svg": "7579",
	"./pickup-agent-hub.svg": "08a1",
	"./pickup-total-pickup.svg": "5a99",
	"./pickup-total-request.svg": "d7f7",
	"./pin-location.svg": "30ed",
	"./plane-booking-active.svg": "43a7",
	"./plane-booking-gray.svg": "8db2",
	"./plane-booking.svg": "8a57",
	"./plane-hanging.svg": "2af1",
	"./plane-icon-black.svg": "1af4",
	"./plane-icon.svg": "26c6",
	"./plane-transit.svg": "f7e6",
	"./play-mov.svg": "a2d5",
	"./play-video.svg": "11f8",
	"./plus-active.svg": "fd8f",
	"./plus-circle-red.svg": "3c7e",
	"./plus-circle-white.svg": "c253",
	"./plus-o.svg": "4997",
	"./plus-solid-red.svg": "63b3",
	"./plus-solid.svg": "10fd",
	"./plus-square.svg": "1c1a",
	"./plus-white.svg": "c5a1",
	"./plus.svg": "1d5d",
	"./pod-dex.svg": "e4e4",
	"./pork.svg": "11d5",
	"./pos-leaderboard-badge-rank-1.svg": "b2ed",
	"./pos-leaderboard-badge-rank-2.svg": "bc0e",
	"./pos-leaderboard-badge-rank-3.svg": "afa6",
	"./pos-leaderboard-badge-rank-4.svg": "7d48",
	"./pos-leaderboard-badge-rank-5.svg": "3360",
	"./ppob-ilustration-1.svg": "a07a",
	"./ppob-ilustration-2.svg": "f8fa",
	"./prev-arrow-red.svg": "8004",
	"./prev-arrow.svg": "f468",
	"./pricing.svg": "a120",
	"./print-label-pending.svg": "faeb",
	"./print-pti.svg": "8b6f",
	"./print-sptj.svg": "0921",
	"./print-summary.svg": "a847",
	"./printer-black.svg": "a5c0",
	"./printer-gray.svg": "e285",
	"./printer-red.svg": "2639",
	"./printer-white.svg": "2b06",
	"./printer.svg": "d263",
	"./product-logo-v3/bigpack-active.svg": "12bf",
	"./product-logo-v3/bigpack-inactive.svg": "545e",
	"./product-logo-v3/bigpackfast-active.svg": "02cd",
	"./product-logo-v3/bigpackfast-inactive.svg": "ca0e",
	"./product-logo-v3/bosspack-active.svg": "36b0",
	"./product-logo-v3/bosspack-inactive.svg": "8915",
	"./product-logo-v3/interpack-active.svg": "60c6",
	"./product-logo-v3/interpack-inactive.svg": "fc9f",
	"./product-logo-v3/interpackmaxi-active.svg": "accb",
	"./product-logo-v3/interpackmaxi-inactive.svg": "7ec6",
	"./product-logo-v3/jagopack-active.svg": "ecef",
	"./product-logo-v3/jagopack-inactive.svg": "f59f",
	"./product-logo-v3/jumbopack-active.svg": "dac3",
	"./product-logo-v3/jumbopack-inactive.svg": "e4e3",
	"./product-logo-v3/minipack-active.svg": "14ef",
	"./product-logo-v3/minipack-inactive.svg": "1d97",
	"./product-logo-v3/onepack-active.svg": "07a1",
	"./product-logo-v3/onepack-inactive.svg": "73d7",
	"./product-logo-v3/otopack150-active.svg": "7f35",
	"./product-logo-v3/otopack150-inactive.svg": "0b7f",
	"./product-logo-v3/otopack250-active.svg": "6fa8",
	"./product-logo-v3/otopack250-inactive.svg": "3be4",
	"./product-logo-v3/regpack-active.svg": "b519",
	"./product-logo-v3/regpack-inactive.svg": "85dd",
	"./product-logo-v3/sameday-active.svg": "37d3",
	"./product-logo-v3/sameday-inactive.svg": "548f",
	"./product-logo-v3/vippack-active.svg": "cb9d",
	"./product-logo-v3/vippack-inactive.svg": "a7f9",
	"./product-logo/bigpack-active.svg": "ad9d",
	"./product-logo/bigpack-inactive.svg": "c722",
	"./product-logo/bigpackfast-active.svg": "2513",
	"./product-logo/bigpackfast-inactive.svg": "192f",
	"./product-logo/bosspack-active.svg": "78e2",
	"./product-logo/bosspack-inactive.svg": "fa8d",
	"./product-logo/interpack-active.svg": "a888",
	"./product-logo/interpack-inactive.svg": "08ea",
	"./product-logo/interpackmaxi-active.svg": "c9de",
	"./product-logo/interpackmaxi-inactive.svg": "efdb",
	"./product-logo/jagopack-active.svg": "8e72",
	"./product-logo/jagopack-inactive.svg": "2b0e",
	"./product-logo/jumbopack-active.svg": "1b90",
	"./product-logo/jumbopack-inactive.svg": "7615",
	"./product-logo/jumbopackh2h-active.svg": "f334",
	"./product-logo/jumbopackh2h-inactive.svg": "854b",
	"./product-logo/minipack-active.svg": "7198",
	"./product-logo/minipack-inactive.svg": "6a24",
	"./product-logo/onepack-active.svg": "9674",
	"./product-logo/onepack-inactive.svg": "9e63",
	"./product-logo/otopack-150-active.svg": "acf7",
	"./product-logo/otopack-150-inactive.svg": "9eaa",
	"./product-logo/otopack-250-active.svg": "1ccc",
	"./product-logo/otopack-250-inactive.svg": "5211",
	"./product-logo/otopack150-active.svg": "45cf",
	"./product-logo/otopack150-inactive.svg": "f87f",
	"./product-logo/otopack250-active.svg": "76e3",
	"./product-logo/otopack250-inactive.svg": "4b13",
	"./product-logo/regpack-active.svg": "9ff9",
	"./product-logo/regpack-inactive.svg": "9a54",
	"./product-logo/sameday-active.svg": "25ad",
	"./product-logo/sameday-inactive.svg": "320d",
	"./product-logo/vippack-active.svg": "6219",
	"./product-logo/vippack-inactive.svg": "48d5",
	"./product-type/bigpack-badge.svg": "63da",
	"./product-type/bigpackfast-badge.svg": "ffb0",
	"./product-type/bosspack-badge.svg": "e298",
	"./product-type/interpack-badge.svg": "495a",
	"./product-type/interpackmaxi-badge.svg": "c947",
	"./product-type/jagopack-badge.svg": "4e3a",
	"./product-type/jumbopack-badge.svg": "e07fd",
	"./product-type/jumbopackh2h-badge.svg": "b14f",
	"./product-type/minipack-badge.svg": "cedc",
	"./product-type/onepack-badge.svg": "f8b2",
	"./product-type/otopack150-badge.svg": "1553",
	"./product-type/otopack250-badge.svg": "43c1",
	"./product-type/regpack-badge.svg": "7acd",
	"./product-type/sameday-badge.svg": "2080",
	"./product-type/vippack-badge.svg": "9d64",
	"./product.svg": "42bf",
	"./profile-login.svg": "61fa",
	"./progressive-commission.svg": "5e32",
	"./qrcode.svg": "d4aa",
	"./radio-button-disable.svg": "8601",
	"./radio-button-filled.svg": "05e9",
	"./radio-button-success.svg": "b513",
	"./rebooking.svg": "39a6",
	"./red-border-check.svg": "6ae5",
	"./referral/banner-referal.svg": "9f9d",
	"./referral/banner-referral-new.png": "2bb7",
	"./referral/referral-register-icon.svg": "2ca7",
	"./refresh-disable.svg": "4763",
	"./refresh-green.svg": "db1d",
	"./refresh-white.svg": "61d2",
	"./refresh.svg": "8129",
	"./rejected.svg": "10ba",
	"./reload-grey.svg": "aaca",
	"./reload-red.svg": "02e4",
	"./reload-white.svg": "102c",
	"./report-red.svg": "c2aa",
	"./report.svg": "5658",
	"./roleManagement.svg": "15d5",
	"./route.svg": "3fd6",
	"./rtc-background-process.svg": "099a",
	"./scan-cargoV2-badges/empty-state.svg": "d908",
	"./scan-cargoV2-badges/error.svg": "5c1d",
	"./scan-cargoV2-badges/success-with-bosspack.svg": "964d",
	"./scan-cargoV2-badges/success-with-dg-bosspack.svg": "a720",
	"./scan-cargoV2-badges/success-with-dg-woodpacking-bosspack-en.svg": "34eb",
	"./scan-cargoV2-badges/success-with-dg-woodpacking-bosspack.svg": "0673",
	"./scan-cargoV2-badges/success-with-dg-woodpacking-en.svg": "7933",
	"./scan-cargoV2-badges/success-with-dg-woodpacking.svg": "bbcd",
	"./scan-cargoV2-badges/success-with-dg.svg": "77c78",
	"./scan-cargoV2-badges/success-with-woodpacking-bosspack-en.svg": "bb4c",
	"./scan-cargoV2-badges/success-with-woodpacking-bosspack.svg": "39b1",
	"./scan-cargoV2-badges/success-with-woodpacking-en.svg": "9cf1",
	"./scan-cargoV2-badges/success-with-woodpacking.svg": "6007",
	"./scan-cargoV2-badges/success.svg": "581b",
	"./scan-flags/bagging_ilust_dg_woodpacking.svg": "3d64",
	"./scan-flags/bagging_ilust_dg_woodpacking_en.svg": "3af8",
	"./scan-flags/bagging_woodpacking.svg": "5cc6",
	"./scan-flags/bagging_woodpacking_en.svg": "ee29",
	"./scan-flags/cargo_dg_woodpacking_example.svg": "99fb",
	"./scan-flags/sti-dest_dg_woodpacking.svg": "cbae",
	"./scan-flags/sti_dg_woodpacking.svg": "518f",
	"./scan-hanging.svg": "4cbc",
	"./scan-qrcode.svg": "f3bf",
	"./search.svg": "8b16",
	"./send-chat-active.svg": "8136",
	"./send-chat.svg": "5007",
	"./sended.svg": "2c34",
	"./separtor_chevron.svg": "ee80",
	"./server-error.svg": "b322",
	"./setor-harian-kurir-red.svg": "6b1a",
	"./setor-harian-kurir.svg": "dd95",
	"./shipment.svg": "7924",
	"./shortcut-booking-client.svg": "2ea8",
	"./shortcut-booking-ilustration.svg": "2600",
	"./shortcut-booking-instant.svg": "e9e44",
	"./shortcut-booking-manual.svg": "56b7",
	"./shortcut-booking-shipment.svg": "68d7",
	"./shortland-hanging.svg": "4bc3",
	"./shortland.svg": "0a94",
	"./snackbar-success.svg": "2efb",
	"./sort-filter-gray.svg": "3736",
	"./sort-filter-red.svg": "72d5",
	"./sort-filter.svg": "eed7",
	"./sort.svg": "bfd7",
	"./sparkles.svg": "5b11",
	"./spot-404.svg": "3bde",
	"./status-failed.svg": "2689",
	"./status-request.svg": "839a",
	"./status-success.svg": "ef39",
	"./sti-active.svg": "00bf",
	"./sti-dest-active.svg": "500f",
	"./sti-dest-hanging.svg": "a03b",
	"./sti-dest-sc-active.svg": "a7b5",
	"./sti-dest-sc.svg": "55dc",
	"./sti-dest-transit/dangerous-goods.svg": "be9b",
	"./sti-dest-transit/woodpacking-en.svg": "ea40",
	"./sti-dest-transit/woodpacking.svg": "147b",
	"./sti-dest.svg": "5c54",
	"./sti-reverse-scan/duplicate-scan-label-en.svg": "6c75",
	"./sti-reverse-scan/duplicate-scan-label.svg": "1666",
	"./sti-reverse-scan/icon-bag-en.svg": "d2a7",
	"./sti-reverse-scan/icon-bag-note-en.svg": "8c8a",
	"./sti-reverse-scan/icon-bag-note.svg": "b880",
	"./sti-reverse-scan/icon-bag.svg": "62e6",
	"./sti-reverse-scan/icon-dangerous-goods-text.svg": "67be",
	"./sti-reverse-scan/icon-dangerous-goods-woodpacking-text-en.svg": "1de4",
	"./sti-reverse-scan/icon-dangerous-goods-woodpacking-text.svg": "6dff",
	"./sti-reverse-scan/icon-dangerous-goods.svg": "c961",
	"./sti-reverse-scan/icon-hal-en.svg": "1cf7",
	"./sti-reverse-scan/icon-hal.svg": "e8b9",
	"./sti-reverse-scan/icon-pod-en.svg": "712a",
	"./sti-reverse-scan/icon-pod.svg": "f5de",
	"./sti-reverse-scan/icon-relabel-en.svg": "c435",
	"./sti-reverse-scan/icon-relabel.svg": "64e8",
	"./sti-reverse-scan/icon-rts-en.svg": "0c63",
	"./sti-reverse-scan/icon-rts.svg": "94f2e",
	"./sti-reverse-scan/icon-scan-failed-en.svg": "d814",
	"./sti-reverse-scan/icon-scan-failed-my.svg": "dfc1",
	"./sti-reverse-scan/icon-scan-failed-underpaid-en.svg": "2307",
	"./sti-reverse-scan/icon-scan-failed-underpaid.svg": "2092",
	"./sti-reverse-scan/icon-scan-failed.svg": "c8b2",
	"./sti-reverse-scan/icon-sti-dest-relabel.svg": "c38f",
	"./sti-reverse-scan/icon-sti-dest.svg": "a9b1",
	"./sti-reverse-scan/icon-sti-sti-dest-bag.svg": "9869",
	"./sti-reverse-scan/icon-sti-sti-dest-hal.svg": "3a93",
	"./sti-reverse-scan/icon-sti-sti-dest-pod-overdue.svg": "7b1c",
	"./sti-reverse-scan/icon-sti-sti-dest-pod-today.svg": "d1fd",
	"./sti-reverse-scan/icon-sti-sti-dest-pod-urgent-delivery.svg": "1b39",
	"./sti-reverse-scan/icon-sti-sti-dest-rts-overdue.svg": "96f4",
	"./sti-reverse-scan/icon-sti-sti-dest-rts-today.svg": "88a0",
	"./sti-reverse-scan/icon-sti-sti-dest-rts-tomorrow.svg": "b86ea",
	"./sti-reverse-scan/icon-sti.svg": "d0e1",
	"./sti-reverse-scan/icon-taken-by-recipient-en.svg": "49d2",
	"./sti-reverse-scan/icon-taken-by-recipient.svg": "6748",
	"./sti-reverse-scan/icon-woodpacking-en.svg": "f020",
	"./sti-reverse-scan/icon-woodpacking.svg": "9cdb",
	"./sti-reverse-scan/scan-empty-state.svg": "c85e",
	"./sti-sc-active.svg": "0b2f",
	"./sti-sc-gray.svg": "4aa3",
	"./sti-sc-reverse-scan/icon-sti-sc.svg": "9311",
	"./sti-sc.svg": "d376",
	"./sti.svg": "9994",
	"./stop-program.svg": "4137",
	"./stt-del-active.svg": "fc6d",
	"./stt-del.svg": "928b",
	"./stt-dex-active.svg": "3ea2",
	"./stt-dex.svg": "f1ac",
	"./stt-not-valid.svg": "0eed",
	"./success-status.svg": "f473",
	"./success.svg": "a868",
	"./summary-dex-complete.svg": "4553",
	"./summary-dex-not-match.svg": "e5ef",
	"./summary-dispute-accept.svg": "5498",
	"./summary-dispute-approved.svg": "27ee",
	"./summary-dispute-rejected.svg": "0ec9",
	"./summary-dispute-requested.svg": "5d13",
	"./summary-total-dex.svg": "9f97",
	"./support-pos-favourite.svg": "5638",
	"./sync-hanging.svg": "da05",
	"./sync-paket.svg": "5dc9",
	"./system-error-console-current-stt.svg": "5a19",
	"./texhnicalConfig.svg": "918a",
	"./thumb_down.svg": "6ce5",
	"./thumb_up.svg": "6aed",
	"./thumb_up_&_thumb_down.svg": "ae2e",
	"./thumb_up_&_thumb_down_disable.svg": "1245",
	"./thumb_up_blue.svg": "2e25",
	"./timer.svg": "5d85",
	"./topup-white-admin.svg": "6483",
	"./topup-white.svg": "b865",
	"./total-active-awb-hanging.svg": "6757",
	"./total-bag-hanging.svg": "682f",
	"./total-stt-hanging.svg": "fbfd",
	"./train-booking-active.svg": "6393",
	"./train-booking.svg": "8fad",
	"./transfer-list-white.svg": "35ae",
	"./transfer-list.svg": "92ff",
	"./trash-red.svg": "5a7d",
	"./trash-white.svg": "fca0",
	"./trash.svg": "07fa",
	"./trash_red.svg": "89fa",
	"./truck-booking-active.svg": "8e1c",
	"./truck-booking.svg": "7d9c",
	"./truck-hanging.svg": "26db",
	"./truck-pickup.svg": "7f1e",
	"./truck-pup.svg": "4ea0",
	"./union-edit.svg": "f0b9",
	"./upload-gray.svg": "fc98",
	"./upload-white.svg": "a8ad",
	"./upload.svg": "f6b2e",
	"./user-avatar-square.svg": "15d9",
	"./user-avatar.svg": "9518",
	"./user-management.svg": "f4f6",
	"./vendor-dex-icon.svg": "4bfb",
	"./wallet-cod-withdrawal.svg": "2368",
	"./warning-circle.svg": "4265",
	"./warning-embargo-detail.svg": "28ee",
	"./warning-embargo.svg": "95a0",
	"./warning-red.svg": "96d2",
	"./warning-yellow.svg": "931d",
	"./warning.svg": "ba7b",
	"./whatsapp.svg": "9660",
	"./white-check.svg": "a284",
	"./withdraw-gray.svg": "904e",
	"./withdraw-red.svg": "19d0",
	"./x-circle-outline-dark-red.svg": "578a",
	"./x-circle-outline-gray.svg": "9e2c",
	"./x-circle-outline.svg": "c1b6",
	"./x-circle-yellow.svg": "15e0",
	"./x-circle.svg": "1910",
	"./x-gray-24.svg": "68be",
	"./x-gray.svg": "371f",
	"./x-red.svg": "96e5",
	"./x-white.svg": "5e42",
	"./x.svg": "05d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36d7";